var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-bottom":"64px"}},[_c('toolbar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }